import { PickerType } from './constants'
import DatePicker from './pickers/DatePicker'
import DateRangePicker from './pickers/DateRangePicker'
import TimePicker from './pickers/TimePicker'
import moment from 'moment-mini'

export default {
  name: 'KDatePickerPane',
  provide() {
    return {
      context: this,
    }
  },
  props: {
    pickerType: String,
    weekStartDay: {
      type: Number,
      default: 7,
    },
    now: moment,
    value: [moment, Array],
    active: Boolean,
    unlinkViews: Boolean,
    shortcuts: Array,
    referenceValue: moment,
    disabledDate: Function,
    precision: String,
    multiple: Boolean,
    paneCount: Number,
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    handlePick(value) {
      this.$emit('input', value)
    },
    handlePicking(value) {
      this.$emit('picking', value)
    },
    handleConfirm(value) {
      this.$emit('confirm', value)
    },
    handleCancel() {
      this.$emit('cancel')
    },
    getBaseData() {
      const events = {
        pick: this.handlePick,
        picking: this.handlePicking,
        confirm: this.handleConfirm,
        cancel: this.handleCancel,
      }

      const data = {
        on: events,
        scopedSlots: this.$scopedSlots,
      }

      return data
    },
    handleStartSelected(value) {
      this.$emit('startSelected', value)
    },
    handleEndSelected(value) {
      this.$emit('endSelected', value)
    },
    getPickerPane() {
      const data = this.getBaseData()

      switch (this.pickerType) {
        case PickerType.Time:
          return (
            <TimePicker
              {...data} />
          )
        case PickerType.DateRange:
          return (
            <DateRangePicker
              {...data}
              onStartSelected={this.handleStartSelected}
              onEndSelected={this.handleEndSelected}
            />
          )
        case PickerType.Date:
        default:
          return (
            <DatePicker
              {...data}
              paneCount={this.paneCount}
            />
          )
      }
    },
  },
  render() {
    return this.getPickerPane()
  },
}
